<template>
    <v-alert border="left" dense colored-border color="orange darken-3" elevation="0" class="px-10 rounded-0">
        <div v-if="!activo">
            <div v-for="item in requisitos" :key="item.text">
                <div class="font-weight-regular text-body-1 mb-1 " v-html="formatText(item.text)">
                </div>
            </div>
        </div>
        <div v-else>
            <div v-for="item in requisitosJubilado" :key="item.text">
                <div class="ma-1" v-html="formatText(item.text)">
                </div>
            </div>
        </div>
    </v-alert>
</template>
<script>

export default {
    components: {
    },
    data() {
        return {
            requisitos: [
                {
                    index: 1,
                    text: 'Si trabajas en una entidad nacional (ej.Anses) deberás anexar certificado laboral que indique lugar de trabajo en el ámbito de la Provincia de Buenos Aires (ej.Udai La Plata).'
                },
                {
                    index: 2,
                    text: 'Si en el recibo de sueldo no consta la categoría profesional deberás anexar un certificado laboral que indique que tu desempeño es como Psicóloga/o'
                },
                {
                    index: 3,
                    text: 'Si trabajas en Educación y en tu recibo no consta la categoría profesional como OE o AE, deberás anexar un certificado laboral que indique que tu desempeño es como Psicóloga/o.)'
                },
                {
                    index: 4,
                    text: 'Si sos docente deberás anexar un certificado laboral que indique la materia que dictás, excepto si sos docente de alguna Facultad de Psicología.'
                },
            ],
            requisitosJubilado: [
                { index: 1, text: 'Para tramitar el nivel 1 deberá adjuntar obligatoriamente el recibo de haberes y la correspondiente resolución de otorgamiento (no en trámite) de la jubilación.' }
            ],

        }
    },
    methods: {
        formatText(text) {
            const boldText = (!this.activo) ? 'certificado laboral' : '(no en trámite)';
            const parts = text.split(boldText);
            return parts.map((part, index) => (index === 0 ? part : `<b class="font-font-weight-bold ">${boldText}</b>${part}`)).join('');
        },
    },
    props: ['activo']

}

</script>